module.exports = __webpack_public_path__ + "static/img/16.f105caf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/16.jpg
// module id = DNQH
// module chunks = 1